import { render, staticRenderFns } from "./PriceTablePTB.vue?vue&type=template&id=2b0fd574&"
import script from "./PriceTablePTB.vue?vue&type=script&lang=js&"
export * from "./PriceTablePTB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports